import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import Header from './Header';
import PublicHeader from './PublicHeader';

const HeaderController = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Hide header completely on article pages, root, and onboarding (full-screen experience)
  const noHeaderRoutes = ['/', '/article', '/articles', '/onboarding'];
  if (noHeaderRoutes.some(route => location.pathname === route || location.pathname.startsWith(route + '/'))) {
    return null;
  }

  // Auth-aware: PublicHeader when logged out, App Header when logged in
  if (!currentUser) {
    return <PublicHeader className="hidden md:block" />;
  }

  return <Header className="hidden md:block" />;
};

export default HeaderController;
